// src/common/area.js
import config from '../config.js';

// Determine the current area based on the URL path, port, and hostname
export function getCurrentArea() {
    if (typeof window !== 'undefined') {
        const path = window.location.pathname;
        const port = window.location.port;
        const hostname = window.location.hostname;
        
        // Production: Check for admin subdomain
        if (hostname.startsWith('admin.')) {
            return 'admin';
        }
        
        // Check port for admin (development or production)
        const adminPortStr = config.ports.admin.toString();
        const currentPortStr = port.toString();
        
        if (currentPortStr === adminPortStr) {
            return 'admin';
        }
        
        // Fallback: Check for production admin port (8081) if config failed
        if (currentPortStr === '8081') {
            return 'admin';
        }
        
        // Check path for admin
        if (path.startsWith('/admin')) {
            return 'admin';
        }
        
        // Check port for user (development or production)
        const userPortStr = config.ports.user.toString();
        
        if (currentPortStr === userPortStr) {
            return 'user';
        }
        
        // Fallback: Check for production user port (8082) if config failed
        if (currentPortStr === '8082') {
            return 'user';
        }
        
        // Default to user area for main domain
        return 'user';
    }
    return 'user'; // default fallback
} 